import { css, cx } from 'emotion';
import {
	lightGrey,
	darkGrey,
	pink,
	textBlock,
	headingSmallLight,
	mobileMaxWidthBreakpoint,
	tabletPortraitMaxWidthBreakpoint,
} from 'inside-out/global-styles';
import MediaIcon from 'inside-out/images/media-icon.svg';
import MediaIconMobile from 'inside-out/images/media-icon-mobile.svg';

const padding = 24;

export const wrapperCardStyle = css({
	position: 'relative',
});

export const wrapperLinkStyle = css({
	textDecoration: 'none',
	display: 'block',
	height: '100%',
});

export const wrapperInnerStyle = css({
	padding: `${padding}px`,
});

export const wrapperStyle = (background, hasVideo, fullWidth) => {
	const baseCSS = {
		position: 'relative',
		textDecoration: 'none',
		border: `1px solid ${lightGrey}`,
		borderRadius: '6px',
		backgroundColor: '#fff',
		boxSizing: 'border-box',
	};

	if (fullWidth) {
		return css({
			...baseCSS,
			minHeight: '160px',
			width: '100%',
			padding: `${padding}px ${padding}px ${padding}px calc(300px + ${padding}px)`,
			[`& .${wrapperInnerStyle}`]: {
				padding: '0',
			},
			'&:after': {
				content: "' '",
				display: 'block',
				position: 'absolute',
				top: 0,
				left: 0,
				width: '300px',
				height: '100%',
				borderRadius: '6px 0 0 6px',
				...(hasVideo
					? {
							backgroundImage: `url(${MediaIcon}), url('${background}')`,
							backgroundPosition: 'center center, center left',
							backgroundSize: '56px 56px, cover',
							backgroundRepeat: 'no-repeat, no-repeat',
							[`@media (max-width: ${mobileMaxWidthBreakpoint}px)`]: {
								backgroundImage: `url(${MediaIconMobile}), url('${background}')`,
								backgroundSize: '40px 40px, cover, cover',
							},
					  }
					: {
							backgroundImage: `url('${background}')`,
							backgroundPosition: 'center left',
							backgroundSize: 'cover',
							backgroundRepeat: 'no-repeat',
					  }),
			},
			[`@media (max-width: ${tabletPortraitMaxWidthBreakpoint}px)`]: {
				paddingLeft: `calc(200px + ${padding}px)`,
				'& p': {
					overflow: 'hidden',
					whiteSpace: 'nowrap',
					textOverflow: 'ellipsis',
				},
				'&:after': {
					width: '200px',
				},
			},
			[`@media (max-width: ${mobileMaxWidthBreakpoint}px)`]: {
				padding: `10px 36px 10px calc(97px + ${padding}px)`, // Image and bookmark padding
				minHeight: '124px',
				'&:after': {
					width: '97px',
					height: '104px',
					transform: 'translateY(-50%)',
					top: '50%',
					left: '10px',
					borderRadius: '6px',
				},
			},
		});
	}

	return css({
		...baseCSS,

		position: 'relative',
		zIndex: '1',
		height: '100%',
		paddingTop: '56.159420289855072%',
		'&:after': {
			borderRadius: '6px 6px 0 0',
			content: "' '",
			display: 'block',
			position: 'absolute',
			top: 0,
			left: 0,
			width: '100%',
			paddingTop: '56.159420289855072%',
			...(hasVideo
				? {
						background: `url(${MediaIcon}), linear-gradient(
					rgba(0, 0, 0, 0.3), 
					rgba(0, 0, 0, 0.3)
				  ), url('${background}')`,
						backgroundRepeat: 'no-repeat',
						backgroundPosition: 'center center, center center, top center',
						backgroundSize: '56px 56px, cover, cover',
						[`@media (max-width: ${mobileMaxWidthBreakpoint}px)`]: {
							backgroundImage: `url(${MediaIconMobile}), linear-gradient(
								rgba(0, 0, 0, 0.3), 
								rgba(0, 0, 0, 0.3)
							  ), url('${background}')`,
							backgroundSize: '40px 40px, cover, cover',
						},
				  }
				: {
						background: `linear-gradient(
					rgba(0, 0, 0, 0.3), 
					rgba(0, 0, 0, 0.3)
				  ), url('${background}')`,
						backgroundRepeat: 'no-repeat',
						backgroundPosition: 'center center, top center',
						backgroundSize: 'cover, cover',
				  }),
		},
	});
};
export const bookmarkButtonStyle = hasBackground =>
	css({
		background: 'none',
		border: 'none',
		padding: 0,
		display: 'inline-block',
		position: 'absolute',
		top: '14px',
		right: '14px',
		zIndex: '2',
		filter: hasBackground ? 'brightness(2)' : null,
		[`@media (max-width: ${mobileMaxWidthBreakpoint}px)`]: {
			top: '10px',
			right: '10px',
		},
	});

export const titleStyle = cx(
	headingSmallLight,
	css({
		marginBottom: '10px',
		color: '#505E64',
		fontWeight: 'normal',
		[`@media (max-width: ${mobileMaxWidthBreakpoint}px)`]: {
			fontSize: '14px',
			lineHeight: '16px',
			color: darkGrey,
		},
	})
);

export const bodyStyle = cx(
	textBlock,
	css({
		marginTop: 0,
		marginBottom: padding - 4,
		[`@media (max-width: ${mobileMaxWidthBreakpoint}px)`]: {
			display: 'none',
		},
	})
);

export const watchTheDemoStyle = css({
	fontSize: '16px',
	lineHeight: '24px',
	marginTop: 0,
	marginBottom: 0,
	color: pink,
	fontWeight: 500,
	/*fontWeight: 'bold'*/
	'& svg': {
		verticalAlign: 'initial',
		marginLeft: '2px',
	},
	[`@media (max-width: ${mobileMaxWidthBreakpoint}px)`]: {
		fontSize: '12px',
	},
});



// WEBPACK FOOTER //
// ./src/components/shared/cards/eLearningCard/styles.js